var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18 10h-5v-.5c0-.828.672-1.5 1.5-1.5h2c.828 0 1.5.672 1.5 1.5zm-2.5-3c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5 1.5.672 1.5 1.5 1.5zm8.5 4-3.525 13h-20.475v-17c0-1.654 1.346-3 3-3v2c-.551 0-1 .448-1 1v15h.268l2.732-8.629v-8.371c0-1.654 1.346-3 3-3h1.184c.414-1.161 1.514-2 2.816-2h7c1.654 0 3 1.346 3 3v8zm-13-8v8h9v-8c0-.552-.449-1-1-1h-7c-.551 0-1 .448-1 1zm-4 2v6h2v-7h-1c-.551 0-1 .448-1 1zm14.402 8h-14.186l-2.85 9h14.582l2.455-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.4cf744c9b47eaf1c9c0da4eceae8f6b2.svg";
export { ForwardRef as ReactComponent };